import { STAGE_COLOR_PALETTE, stageColor } from '../utils/taskProgress.js';

export function StageColorField({ value, onChange, label = 'Color' }) {
  const current = stageColor({ color: value });

  return (
    <label className="field task-stage-color">
      <span>{label}</span>
      <div className="task-stage-swatches">
        {STAGE_COLOR_PALETTE.map((color) => (
          <button
            key={color}
            type="button"
            className={current === color ? 'is-selected' : ''}
            style={{ background: color }}
            aria-label={`Column color ${color}`}
            aria-pressed={current === color}
            onClick={() => onChange(color)}
          />
        ))}
        <input
          type="color"
          value={current}
          aria-label="Custom column color"
          onChange={(event) => onChange(String(event.target.value || '').toUpperCase())}
        />
      </div>
    </label>
  );
}
